import { GetServerSideProps, NextPage } from 'next'
import { GlobalRequest } from '~/components/global-request'
import { MyContainer } from '~/components/ui/MyContainer'
import { Layout } from '~/layouts/default'
import { PageCrumbs } from '~/components/business/PageCrumbs'
import { HtmlContent } from '~/components/ui/HtmlContent'
import { AGREEMENT_PRFIX_KEY } from '~/configs'

import * as api from '~/apis'
import { SEOHead } from '~/components/business/SEOHead'

const Page: NextPage<{
  data: any
}> = ({ data }) => {
  return (
    <Layout>
      <SEOHead title="隐私政策" />
      <MyContainer>
        <PageCrumbs title="隐私政策" center dark />
        <HtmlContent data={data.content} />
      </MyContainer>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState } = await GlobalRequest(context)
  const dataRes = await api.getConfig({
    data: {
      key: AGREEMENT_PRFIX_KEY + '.privacy',
    },
  })

  return {
    props: {
      initialState,
      data: JSON.parse(dataRes.data.data) || {},
    },
  }
}

export default Page
